/**
 * Database type.
 */
export type DatabaseType =
    | "postgres"
    | "sqlite"
    | "sqlite-pooled"
